
export class Rapports {
    id_rap:any;
    dat_deb_rap  :any;
    dat_fin_rap :any;
    libelle :any;
    document :any;
    etat :any="c";
    mat_pers :any

    constructor( id_rap:any){
      
    }
}
